import { faStar } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function GradeLine() {
    return (
        <div className="flex w-fit flex-col gap-1">
            <div className="flex gap-2">
                {[1, 2, 3, 4, 5].map((val) => (
                    <FontAwesomeIcon
                        key={val}
                        icon={faStar}
                        className="text-compendia-greige size-8"
                    />
                ))}
            </div>
        </div>
    );
}
